import React, { useState, useEffect } from 'react';
import { Button, Switch } from 'antd';
import { RewardList as RewardListContainer } from '../../../RnRCommonComponent';
// import CoreBadge from '../../../RnRCommonComponent/CoreBadge/CoreBadge';
import {
	BADGE_TYPE,
	REVERSE_MAPING_BADGE_TYPE,
	ICON_COMPLETE_MAP,
} from '../../../RnRCommonComponent/CoreBadge/rewardsConstants.js';
import { motion } from 'motion/react';
import { RecognitionEditor } from 'src/manageRewards/RecognitionEditor';
import Automated from '../../../assets/svg/automated.svg';
import NoDataState from '../../../RnRCommonComponent/noDataState/NoDataState.jsx';
import { withApollo } from 'react-apollo';
import { gql } from 'graphql-tag';

const ManageRewardContainer = ({ currentUser, client }) => {
	const QUERY_BADGES_BY_COMPANY_ID = gql`
		query QueryBadgesByCompanyIdIndex(
			$companyId: ID!
			$limit: Int
			$nextToken: String
		) {
			queryBadgesByCompanyIdIndex(
				companyId: $companyId
				limit: $limit
				nextToken: $nextToken
			) {
				items {
					id
					allowSelfNomination
					companyId
					badgeTypeId
					badgeLimitPerUser {
						limit
						frequency
					}
					assignmentSSORequiredId
					recipientPayTypeId
					recipientSSORequiredId
					physicalAwardActivityId
					iconId
					snappyGrantId
					snappyGrant {
						id
						externalSnappyId
						snappyCampaignId
						name
						description
						costInCurrency
					}
					name
					milestoneYears
					label
					description
					image
					color
					gradientColor
					points
					shape
					category
					bonusPoints
					rewardBonus
					rewardMaxBonus
					assignmentLimit
					assignmentLevelId
					recipientLevelId
					isAssignmentRestricted
					isPreApproved
					isRewardRequiresDate
					visibility
					isAssignmentSSORequired
					isRecipientSSORequired
					automationRule
					externalWorkFlowId
					milestoneRewardId
					badgeRotation
					customImageKey
					customImageSignedUrl
					labelColor
					customIconKey
					customIconSignedUrl
				}
				nextToken
			}
		}
	`;

	const GET_BADGE_BY_ID = gql`
		query GetBadgeById($companyId: ID!, $id: ID!) {
			getBadgeById(companyId: $companyId, id: $id) {
				allowSelfNomination
				assignmentLevelId
				assignmentLimit
				assignmentSSORequiredId
				automationRule
				badgeTypeId
				badgeLimitPerUser {
					limit
					frequency
				}
				bonusPoints
				category
				color
				createdAt
				companyId
				createdBy
				deletedBy
				deletedAt
				description
				gradientColor
				externalWorkFlowId
				image
				iconId
				id
				isPreApproved
				isAssignmentRestricted
				isAssignmentSSORequired
				isRewardRequiresDate
				isRecipientSSORequired
				label
				points
				milestoneYears
				name
				physicalAwardActivityId
				recipientLevelId
				recipientPayTypeId
				recipientSSORequiredId
				rewardBonus
				rewardMaxBonus
				shape
				snappyGrant {
					snappyCampaign {
						name
						companyId
						id
					}
					externalSnappyId
					snappyCampaignTierId
					snappyCampaignId
					pointsRequired
					description
					name
					costInCurrency
				}
				snappyGrantId
				updatedAt
				updatedBy
				visibility
				certificateConfig {
					id
					name
					key
				}
				badgeRotation
				customImageKey
				customImageSignedUrl
				labelColor
				customIconKey
				customIconSignedUrl
				milestoneRewardId
				milestoneReward {
					id
					name
					image
				}
			}
		}
	`;

	const QUERY_SNAPPY_GRANTS_BY_COMPANY_ID = gql`
		query QuerySnappyGrantsByCompanyId(
			$companyId: ID!
			$limit: Int
			$nextToken: String
		) {
			querySnappyGrantsByCompanyId(
				companyId: $companyId
				limit: $limit
				nextToken: $nextToken
			) {
				items {
					id
					name
					description
					externalSnappyId
					companyId
					snappyCampaignId
					snappyCampaignTierId
					active
					allowOverBudget
					allowMultipleGrants
					allowForNominations
					allowRevoke
					requireApproval
					allowAssignmentNoGift
					grantCategory
					costInCurrency
					currencyIsoCode
					currencySymbol
					giftExpiryDays
					remainingAssignments
					totalAssignments
					badgeIds
					badgeAssignmentIds
					snappyGiftIds
					isHidden
					isArchived
					isMirroredSnappyCampaignTier
					externalInformation
					redemptionLogs
					createdBy
					createdAt
					updatedBy
					updatedAt
				}
				nextToken
			}
		}
	`;

	const [showEditModal, setShowEditModal] = useState(false);
	const [showCreateModal, setShowCreateModal] = useState(false);
	const [selectedBadge, setSelectedBadge] = useState();
	const [detailedBadge, setDetailedBadge] = useState(null);
	const [shouldRefresh, setShouldRefresh] = useState(false);
	const [groupingMode, setGroupingMode] = useState('badgeType'); // 'badgeType' or 'category'
	const [badges, setBadges] = useState({
		peerToPeer: [],
		nominated: [],
		automated: [],
		biztechBehavior: [],
		coreValue: [],
	});
	const [categoryBadges, setCategoryBadges] = useState({});
	const [isLoading, setIsLoading] = useState(true);
	const [snappyGrants, setSnappyGrants] = useState([]);
	const [isLoadingBadgeDetails, setIsLoadingBadgeDetails] = useState(false);
	const [nextToken, setNextToken] = useState(null);
	const [hasMoreBadges, setHasMoreBadges] = useState(false);
	const [isLoadingMore, setIsLoadingMore] = useState(false);
	const isAirBnb =
		currentUser?.company?.id === 'c816b4bf-a851-4bdb-bf4e-a5c9cd27bef1';

	const processBadgesByCategory = (badgeItems, isAppending = false) => {
		const enrichedBadges = badgeItems.map((badge) => {
			const badgeType = REVERSE_MAPING_BADGE_TYPE[badge.badgeTypeId] || '';

			let iconInfo = null;
			if (badge.iconId) {
				iconInfo = ICON_COMPLETE_MAP.find((icon) => icon.id === badge.iconId);
			}

			return {
				...badge,
				badgeType,
				iconInfo,
			};
		});

		const groupedByCategory = enrichedBadges.reduce((acc, badge) => {
			const category = badge.category || 'Default';
			if (!acc[category]) {
				acc[category] = [];
			}
			acc[category].push(badge);
			return acc;
		}, {});

		if (isAppending) {
			setCategoryBadges((prevCategoryBadges) => {
				const newCategoryBadges = { ...prevCategoryBadges };
				Object.keys(groupedByCategory).forEach((category) => {
					if (newCategoryBadges[category]) {
						newCategoryBadges[category] = [
							...newCategoryBadges[category],
							...groupedByCategory[category],
						];
					} else {
						newCategoryBadges[category] = groupedByCategory[category];
					}
				});
				return newCategoryBadges;
			});
		} else {
			setCategoryBadges(groupedByCategory);
		}
	};

	const processBadges = (badgeItems, isAppending = false) => {
		const enrichedBadges = badgeItems.map((badge) => {
			const badgeType = REVERSE_MAPING_BADGE_TYPE[badge.badgeTypeId] || '';

			let iconInfo = null;
			if (badge.iconId) {
				iconInfo = ICON_COMPLETE_MAP.find((icon) => icon.id === badge.iconId);
			}

			return {
				...badge,
				badgeType,
				iconInfo,
			};
		});

		const allPeerToPeer = enrichedBadges.filter(
			(badge) => badge.badgeType === 'PEERTOPEER'
		);

		const nominated = enrichedBadges.filter(
			(badge) => badge.badgeType === 'NOMINATED'
		);

		const automated = enrichedBadges.filter(
			(badge) => badge.badgeType === 'AUTOMATED'
		);

		// For AirBnb, separate peer-to-peer badges by name categories
		if (isAirBnb) {
			const biztechBehavior = allPeerToPeer.filter((badge) =>
				badge.name?.startsWith('BizTech Behavior')
			);

			const coreValue = allPeerToPeer.filter((badge) =>
				badge.name?.startsWith('Core Value')
			);

			const otherPeerToPeer = allPeerToPeer.filter(
				(badge) =>
					!badge.name?.startsWith('BizTech Behavior') &&
					!badge.name?.startsWith('Core Value')
			);

			if (isAppending) {
				setBadges((prevBadges) => ({
					peerToPeer: [...prevBadges.peerToPeer, ...otherPeerToPeer],
					nominated: [...prevBadges.nominated, ...nominated],
					automated: [...prevBadges.automated, ...automated],
					biztechBehavior: [...prevBadges.biztechBehavior, ...biztechBehavior],
					coreValue: [...prevBadges.coreValue, ...coreValue],
				}));
			} else {
				setBadges({
					peerToPeer: otherPeerToPeer,
					nominated,
					automated,
					biztechBehavior,
					coreValue,
				});
			}
		} else {
			if (isAppending) {
				setBadges((prevBadges) => ({
					peerToPeer: [...prevBadges.peerToPeer, ...allPeerToPeer],
					nominated: [...prevBadges.nominated, ...nominated],
					automated: [...prevBadges.automated, ...automated],
					biztechBehavior: [],
					coreValue: [],
				}));
			} else {
				setBadges({
					peerToPeer: allPeerToPeer,
					nominated,
					automated,
					biztechBehavior: [],
					coreValue: [],
				});
			}
		}

		// Also process by category for the category view
		processBadgesByCategory(badgeItems, isAppending);
	};

	const fetchBadgesByCompany = async (
		tokenToUse = null,
		isAppending = false
	) => {
		if (client && currentUser?.companyId) {
			try {
				if (!isAppending) {
					setIsLoading(true);
				} else {
					setIsLoadingMore(true);
				}

				const { data, error } = await client.query({
					query: QUERY_BADGES_BY_COMPANY_ID,
					variables: {
						companyId: currentUser.companyId,
						limit: 5000,
						nextToken: tokenToUse,
					},
					fetchPolicy: 'network-only',
				});

				if (error) {
					console.error('Error fetching badges by company ID:', error);
					return;
				}

				if (data?.queryBadgesByCompanyIdIndex?.items) {
					processBadges(data.queryBadgesByCompanyIdIndex.items, isAppending);

					const newNextToken = data.queryBadgesByCompanyIdIndex.nextToken;
					setNextToken(newNextToken);
					setHasMoreBadges(!!newNextToken);
				}
			} catch (error) {
				console.error('Exception when fetching badges by company ID:', error);
			} finally {
				setIsLoading(false);
				setIsLoadingMore(false);
			}
		}
	};

	const fetchMoreBadges = async () => {
		if (nextToken && !isLoadingMore) {
			await fetchBadgesByCompany(nextToken, true);
		}
	};

	const getSnappyGrants = async () => {
		try {
			const companyId = currentUser?.companyId || currentUser?.company?.id;
			if (!companyId) {
				console.error('Company ID not found');
				return;
			}

			const { data } = await client.query({
				query: QUERY_SNAPPY_GRANTS_BY_COMPANY_ID,
				variables: {
					companyId: companyId,
					limit: 1000,
					nextToken: null,
				},
				fetchPolicy: 'network-only',
			});
			if (data?.querySnappyGrantsByCompanyId?.items) {
				setSnappyGrants(data.querySnappyGrantsByCompanyId.items);
			} else {
				setSnappyGrants([]);
			}
		} catch (error) {
			console.error('Error fetching campaigns:', error);
			setSnappyGrants([]);
		}
	};

	useEffect(() => {
		fetchBadgesByCompany();
		getSnappyGrants();
	}, [client, currentUser]);

	useEffect(() => {
		if (shouldRefresh) {
			setNextToken(null);
			setHasMoreBadges(false);
			fetchBadgesByCompany();
			setShouldRefresh(false);
		}
	}, [shouldRefresh]);

	const handleShowCreateModal = () => {
		setShowCreateModal(true);
	};

	const handleCloseCreateModal = () => {
		setShowCreateModal(false);
	};

	const handleSaveRecognition = (savedRecognition) => {
		setNextToken(null);
		setHasMoreBadges(false);
		fetchBadgesByCompany();
	};

	const handleIconClickEvent = async (badge) => {
		setSelectedBadge(badge);

		try {
			setIsLoadingBadgeDetails(true);

			const { data, error } = await client.query({
				query: GET_BADGE_BY_ID,
				variables: {
					companyId: currentUser.companyId,
					id: badge.id,
				},
				fetchPolicy: 'network-only',
			});

			if (error) {
				console.error('Error fetching badge details:', error);
			}

			if (data?.getBadgeById) {
				const badgeType =
					REVERSE_MAPING_BADGE_TYPE[data.getBadgeById.badgeTypeId] || '';
				let iconInfo = null;

				if (data.getBadgeById.iconId) {
					iconInfo = ICON_COMPLETE_MAP.find(
						(icon) => icon.id === data.getBadgeById.iconId
					);
				}

				const enrichedDetailedBadge = {
					...data.getBadgeById,
					badgeType,
					iconInfo,
					snappyGrantId: data.getBadgeById.snappyGrantId || null,
				};

				setDetailedBadge(enrichedDetailedBadge);
			}
		} catch (error) {
			console.error('Exception when fetching badge details:', error);
		} finally {
			setIsLoadingBadgeDetails(false);
			setShowEditModal(true);
		}
	};

	return (
		<>
			<div className="main">
				<div className="page-title">
					<h2 className="page-heading-manage-reward">Manage Recognitions</h2>
					<div style={{ display: 'flex' }}>
						<Button
							type="link"
							className="add-btn btn-lg create-reward"
							onClick={handleShowCreateModal}
						>
							<span className="icon-circle">
								<b className="icon-plus" />
							</span>
							<span>Create Recognition</span>
						</Button>
					</div>
				</div>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: '12px',
						marginBottom: '20px',
						padding: '12px 16px',
						//backgroundColor: '#f8f9fa',
						borderRadius: '8px',
						//border: '1px solid #e9ecef'
					}}
				>
					<span style={{ fontWeight: '700', color: '#151719ff' }}>
						Group by:
					</span>
					<span
						style={{
							color:
								groupingMode === 'badgeType'
									? 'oklch(0.2998 0.034 260.85)'
									: 'oklch(0.2998 0.034 260.85)',
						}}
					>
						Badge Type
					</span>
					<Switch
						checked={groupingMode === 'category'}
						onChange={(checked) =>
							setGroupingMode(checked ? 'category' : 'badgeType')
						}
						size="default"
						style={
							groupingMode === 'category'
								? { backgroundColor: 'oklch(0.6757 0.187 349.98)' }
								: {}
						}
					/>
					<span
						style={{
							color:
								groupingMode === 'category'
									? 'oklch(0.6757 0.187 349.98)'
									: 'oklch(0.2998 0.034 260.85)',
						}}
					>
						Category
					</span>
				</div>
			</div>

			{showEditModal && (
				<div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
					<motion.div
						initial={{ scale: 0.9, opacity: 0 }}
						animate={{ scale: 1, opacity: 1 }}
						exit={{ scale: 0.9, opacity: 0 }}
						className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
					>
						<RecognitionEditor
							badge={detailedBadge || selectedBadge}
							snappyGrants={snappyGrants}
							visible={showEditModal}
							onSave={handleSaveRecognition}
							onCancel={() => {
								setShowEditModal(false);
								setDetailedBadge(null);
								setSelectedBadge(null);
							}}
						/>
					</motion.div>
				</div>
			)}

			{showCreateModal && (
				<div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
					<motion.div
						initial={{ scale: 0.9, opacity: 0 }}
						animate={{ scale: 1, opacity: 1 }}
						exit={{ scale: 0.9, opacity: 0 }}
						className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
					>
						<RecognitionEditor
							badge={null}
							snappyGrants={snappyGrants}
							visible={showCreateModal}
							onSave={handleSaveRecognition}
							onCancel={handleCloseCreateModal}
						/>
					</motion.div>
				</div>
			)}

			<div className="row">
				<div className="col-12">
					{isLoading ? (
						<div className="loading-container">Loading badges...</div>
					) : (
						<>
							{groupingMode === 'badgeType' ? (
								<>
									{isAirBnb ? (
										<>
											<RewardListContainer
												client={client}
												currentUser={currentUser || {}}
												handleIconClickEvent={handleIconClickEvent}
												title="BizTech Behavior"
												badgeType={BADGE_TYPE.PEERTOPEER}
												shouldRefresh={shouldRefresh}
												setShouldRefresh={setShouldRefresh}
												isDetailsShown={true}
												isPointsShown={false}
												isIssuedVisible={true}
												customHeight="500px"
												useCustomData={false}
											/>
											<RewardListContainer
												client={client}
												currentUser={currentUser || {}}
												handleIconClickEvent={handleIconClickEvent}
												title="Core Value"
												badgeType={BADGE_TYPE.PEERTOPEER}
												shouldRefresh={shouldRefresh}
												setShouldRefresh={setShouldRefresh}
												isDetailsShown={true}
												isPointsShown={false}
												isIssuedVisible={true}
												customHeight="500px"
												useCustomData={false}
											/>
										</>
									) : (
										<>
											<RewardListContainer
												client={client}
												currentUser={currentUser || {}}
												handleIconClickEvent={handleIconClickEvent}
												title="On-The-Spot Recognitions"
												badgeType={BADGE_TYPE.PEERTOPEER}
												shouldRefresh={shouldRefresh}
												setShouldRefresh={setShouldRefresh}
												isDetailsShown={true}
												isPointsShown={false}
												isIssuedVisible={true}
												useCustomData={false}
											/>
											<RewardListContainer
												client={client}
												currentUser={currentUser || {}}
												handleIconClickEvent={handleIconClickEvent}
												title="Milestones"
												titleLink="/manage-milestones"
												titleLinkText="Manage Milestones"
												badgeType={BADGE_TYPE.AUTOMATED}
												shouldRefresh={shouldRefresh}
												setShouldRefresh={setShouldRefresh}
												isDetailsShown={true}
												isPointsShown={false}
												isIssuedVisible={true}
												useCustomData={false}
											/>
										</>
									)}
									{!isAirBnb && (
										<RewardListContainer
											client={client}
											currentUser={currentUser || {}}
											handleIconClickEvent={handleIconClickEvent}
											title="Nominations"
											badgeType={BADGE_TYPE.NOMINATED}
											shouldRefresh={shouldRefresh}
											setShouldRefresh={setShouldRefresh}
											isDetailsShown={true}
											isPointsShown={false}
											isIssuedVisible={true}
											useCustomData={false}
										/>
									)}
								</>
							) : (
								<>
									{Object.entries(categoryBadges).map(
										([category, categoryBadgeList]) => (
											<RewardListContainer
												key={category}
												client={client}
												currentUser={currentUser || {}}
												handleIconClickEvent={handleIconClickEvent}
												title={category}
												badgeType={null}
												shouldRefresh={false}
												setShouldRefresh={() => {}}
												isDetailsShown={true}
												isPointsShown={false}
												isIssuedVisible={true}
												useCustomData={true}
												badges={categoryBadgeList}
												hasMore={false}
												fetchMoreData={() => {}}
												isLoadingMore={false}
											/>
										)
									)}
								</>
							)}
						</>
					)}
					{/* {!isLoading && !isAirBnb && (
						<div className="d-card ">
							<div className="d-card-head">
								<h4 className="d-title-no-case">{"Automated Recognitions"}</h4>
							</div>
							<div style={{
								maxHeight: "220px",
								height: "100%",
								overflow: "unset",
							}}>
								<div className="badges-list-flex">
									{badges.automated.length === 0 ? (
										<NoDataState title={"No automated recognitions generated yet."} />
									) : (
										badges.automated.map(badge => {
											const hasSnappyId = !!badge.snappyGrantId;
											const isManagerOrAdmin = ['manager', 'admin', 'superAdmin', 'supportAdmin'].includes(currentUser?.role?.toLowerCase());
											
											const snappyDetails = hasSnappyId ? {
												id: badge.snappyGrantId,
												name: badge.snappyGrant?.name || 'Snappy Reward',
												costInCurrency: `$${badge.snappyGrant?.costInCurrency || 0}`
											} : {};
											
											const hideSnappyIcon = !(hasSnappyId && isManagerOrAdmin);
											
											return (
												<div
													key={badge.id}
													className='badges-container'
													style={{ opacity: 1 }}>
													<div
														className='badges-container-edit-target'
														style={{ cursor: 'pointer' }}
														onClick={() => handleIconClickEvent(badge)}
													>
														<div className="badges-img">
															{badge.iconInfo ? (
																<div className='badges-svg'>
																	<CoreBadge
																		badgeType={badge.badgeType}
																		badgeIcon={badge.iconInfo.icon || "AWARD"}
																		label={badge.name || "Badge"}
																		color={badge.color || "#6366f1"}
																		gradientColor={badge.gradientColor || "#10b981"}
																		shape={badge.shape}
																		badgeRotation={badge.badgeRotation}
																		customImageSignedUrl={badge.customImageSignedUrl}
																		labelColor={badge.labelColor}
																		customIconSignedUrl={badge.customIconSignedUrl}
																		hideSnappyIcon={hideSnappyIcon}
																		snappyDetails={snappyDetails}
																	/>
																</div>
															) : (
																<div className='badges-svg'>
																	<img src={Automated} alt='Badge' />
																</div>
															)}
														<div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
															<div style={{ marginBottom: "-0.5rem" }}>{badge.issuedCount || 0}</div>
															<div>Issued</div>
														</div>
													</div>
												</div>
												<div style={{
													display: "flex",
													justifyContent: "center",
													marginTop: "2px"
												}}>
													<Button
														type='link'
														className="text-center img-label"
														onClick={() => handleIconClickEvent(badge)}
													>
														Details
													</Button>
												</div>
											</div>
										)})
									)}
								</div>
							</div>
						</div>
					)} */}
				</div>
			</div>
		</>
	);
};

export default withApollo(ManageRewardContainer);
